import styled from 'styled-components'
import { ResponsiveSpaceScaleValue } from '../../styles/stylePropTypes'
import Box, { BoxProps } from './Box'

// A spacer component takes all the props a Box does, and adds the "space" prop
export type Props = BoxProps & {
  space?: ResponsiveSpaceScaleValue
}

const Row = styled(Box).attrs<Props>(props => ({
  display: 'flex',
  gap: props.space,
}))<Props>``

export default Row
